import {ApiObject} from "./api"
import {ApiObjectFields, EOFields, 
  Guid, WarehouseCode,
} from "./types"
import {
  GuidTypeMap, StringTypeMap, NumericBooleanTypeMap, WarehouseCodeTypeMap
} from "./generaltypemaps"

export const WarehouseFields = {
  iD: GuidTypeMap,
  code: WarehouseCodeTypeMap,
  description: StringTypeMap,
  main: NumericBooleanTypeMap,
}


export class Warehouse extends ApiObject
    implements ApiObjectFields<typeof WarehouseFields> {
  readonly iD: Guid
  readonly description: string
  readonly code: WarehouseCode
  readonly main: 0 | 1

  constructor(props: EOFields<typeof Warehouse>) {
    super({})
    this.iD = Warehouse.FIELDS.iD.fromEO(props.ID)
    this.description = Warehouse.FIELDS.description.fromEO(props.Description)
    this.code = Warehouse.FIELDS.code.fromEO(props.Code)
    this.main = Warehouse.FIELDS.main.fromEO(props.Main)
  }

  static get FIELDS(): typeof WarehouseFields {
    return WarehouseFields
  }

  static get URL(): string {
    return "inventory/Warehouses"
  }
}

